class ScrollCurrentChecker {
  constructor(elms) {
    this.dom = {elms: elms};
    this.dom.stickyNav = document.querySelector('[data-js="sticky-nav"]');

    // 今回の交差を監視する要素
    this.sections = this.dom.elms;
    this.options = {
      root: null, // 今回はビューポートをルート要素とする
      rootMargin: "-50% 0px", // ビューポートの中心を判定基準にする
      threshold: 0 // 閾値は0
    };
    this.init();
  }
  init() {
    // そのままだとdoWhenIntersect()のthisはIntersectionObserverを見てしまうので、.bind(this)で本体classを渡す
    const observer = new IntersectionObserver(this.doWhenIntersect.bind(this), this.options);
    // それぞれのsectionを監視する
    this.sections.forEach(section => {
      observer.observe(section);
    });
  }
  doWhenIntersect(entries) {
    // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.activateIndex(entry.target);
      }
    });
  }
  activateIndex(element) {
    // すでにアクティブになっている目次を選択
    const currentActiveIndex = this.dom.stickyNav.querySelector('[data-js="nav-list"][data-is="current"]');
    // すでにアクティブになっているものが0個の時（=null）以外は、activeクラスを除去
    if (currentActiveIndex !== null) {
      currentActiveIndex.removeAttribute('data-is');
    }
    // 引数で渡されたDOMが飛び先のaタグを選択し、activeクラスを付与
    const id = element.getAttribute('id');
    const newActiveIndex = this.dom.stickyNav.querySelector(`a[href="#${id}"]`).parentElement;
    // const newActiveIndex = document.querySelector(`a[href='#${element.id}']`);
    newActiveIndex.dataset.is = 'current';
  }
}

export default ScrollCurrentChecker